import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const API_BASE = process.env.REACT_APP_API_BASE || "";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [role, setRole] = useState("user");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emailMasked, setEmailMasked] = useState("");
  const [sending, setSending] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const sendCode = async () => {
    if (!/^1[3-9]\d{9}$/.test(phone.trim())) {
      alert("请输入正确的手机号");
      return;
    }
    setSending(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/send-email-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          role,
          phone: phone.trim(),
          purpose: "reset_password",
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        alert(data.detail || "发送失败");
        return;
      }
      setEmailMasked(data.email_masked || "");
      alert(
        data.dev_hint
          ? `${data.message}\n验证码已发到绑定邮箱（开发模式请查看后端控制台）`
          : `验证码已发送到 ${data.email_masked}`
      );
    } catch {
      alert("请求失败，请确认后端已启动");
    } finally {
      setSending(false);
    }
  };

  const handleSubmit = async () => {
    if (!phone.trim() || !code.trim() || !newPassword) {
      alert("请填写完整信息");
      return;
    }
    if (newPassword.length < 6) {
      alert("新密码至少 6 位");
      return;
    }
    if (newPassword !== confirmPassword) {
      alert("两次输入的新密码不一致");
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          role,
          phone: phone.trim(),
          code: code.trim(),
          new_password: newPassword,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        alert(data.detail || "重置失败");
        return;
      }
      alert("密码已重置，请使用新密码登录");
      navigate("/login");
    } catch {
      alert("请求失败");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex flex-col">
      <Header />
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-2xl font-bold text-gray-800 text-center mb-2">
            忘记密码
          </h1>
          <p className="text-sm text-gray-500 text-center mb-6">
            输入注册手机号，验证码将发送到您绑定的邮箱
          </p>

          <div className="flex gap-2 mb-4">
            <button
              type="button"
              onClick={() => setRole("user")}
              className={`flex-1 py-2 rounded-lg text-sm ${
                role === "user"
                  ? "bg-pink-500 text-white"
                  : "bg-gray-100 text-gray-600"
              }`}
            >
              会员
            </button>
            <button
              type="button"
              onClick={() => setRole("consultant")}
              className={`flex-1 py-2 rounded-lg text-sm ${
                role === "consultant"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-100 text-gray-600"
              }`}
            >
              咨询师
            </button>
          </div>

          <div className="space-y-3">
            <input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="注册手机号"
              className="w-full border rounded-xl px-4 py-3 text-sm"
            />

            <div className="flex gap-2">
              <input
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="邮箱验证码"
                className="flex-1 border rounded-xl px-4 py-3 text-sm"
              />
              <button
                type="button"
                onClick={sendCode}
                disabled={sending}
                className="shrink-0 px-4 py-3 rounded-xl bg-pink-500 text-white text-sm disabled:opacity-50"
              >
                {sending ? "发送中…" : "获取验证码"}
              </button>
            </div>

            {emailMasked ? (
              <p className="text-xs text-blue-600">验证码已发送至：{emailMasked}</p>
            ) : null}

            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="新密码（至少 6 位）"
              className="w-full border rounded-xl px-4 py-3 text-sm"
            />
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="确认新密码"
              className="w-full border rounded-xl px-4 py-3 text-sm"
            />

            <button
              type="button"
              onClick={handleSubmit}
              disabled={submitting}
              className="w-full py-3 rounded-xl bg-pink-500 text-white font-medium disabled:opacity-50"
            >
              {submitting ? "提交中…" : "重置密码"}
            </button>

            <p className="text-xs text-gray-500 text-center leading-relaxed">
              若尚未绑定邮箱，请先登录后在左侧「账号安全」中绑定邮箱。
            </p>

            <div className="text-center">
              <Link to="/login" className="text-sm text-pink-600 hover:underline">
                返回登录
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
